import React from "react";
import { Card, List } from "antd";

const TeamAttendanceWidget = () => {
  const team = [
    { name: "John", status: "Present" },
    { name: "Neha", status: "Absent" },
  ];

  return (
    <Card title="Team Attendance Today" bordered={false}>
      <List
        dataSource={team}
        renderItem={(i) => (
          <List.Item>
            <b>{i.name}</b> — {i.status}
          </List.Item>
        )}
      />
    </Card>
  );
};

export default TeamAttendanceWidget;
